export const GET_PRESS_RELEASE = 'pressRelease/GET_PRESS_RELEASE';
